import React from 'react';
import './Modal.scss';

const Modal = ({onClose, data}) => {
    let className = null;
    if (data) className = data.type === 'th' ? 'base-blue' : 'base-green';
    else return null;
    return (
        <div id="wtm-modal" className="wtm-modal" onClick={onClose}>
            <section className={`modal-wrapper ${className}`} data-keyboard="false" data-backdrop="static">
                {/*<div className="header">*/}
                    {/*<button className={`btn-close ${className}`} onClick={onClose}>X</button>*/}
                {/*</div>*/}
                <div className="speaker">
                    <div className="profile">
                        <h1 className={`name ${className}`}>{data.profile.name}</h1>
                        <div>
                            {data.profile.src.map(img => (<img className="img" src={img} alt="WTM SEOUL 2019 SPEAKER"/>))}
                        </div>
                    </div>
                    <div className="session">
                        <div className="inner-session">
                            <h1 className={`title ${className}`}>{data.event.title}</h1>
                            {
                                data.event.desc.split('\n').map((str, index) => {
                                    return <p key={`desc-${index}`} className={`desc ${className}`}>{str}</p>;
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className="introduction">
                    <p className={`desc ${className}`}>
                        {data.profile.desc}
                    </p>
                </div>

            </section>
        </div>
    );
};


export default Modal;
